import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTeamMeeting = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "team-meeting" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 4.499,
			cy: 17.625,
			r: 2.625
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.249,23.25a4.25,4.25,0,0,0-7.5,0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 19.499,
			cy: 17.625,
			r: 2.625
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.249,23.25a4.25,4.25,0,0,0-7.5,0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 11.999,
			cy: 3.375,
			r: 2.625
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.248,8.25a4.269,4.269,0,0,0-6.5,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9.05,19.707a8.277,8.277,0,0,0,5.944-.018"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.348,6a8.217,8.217,0,0,0-2.6,6c0,.253.015.5.038.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.211,12.75c.022-.248.038-.5.038-.75a8.214,8.214,0,0,0-2.6-6"
		})
	]
});
export default SvgTeamMeeting;
